import { render, staticRenderFns } from "./block-documents-mass-share-results.vue?vue&type=template&id=4a8c81f7&scoped=true&lang=pug"
import script from "./block-documents-mass-share-results.vue?vue&type=script&lang=js"
export * from "./block-documents-mass-share-results.vue?vue&type=script&lang=js"
import style0 from "./block-documents-mass-share-results.vue?vue&type=style&index=0&id=4a8c81f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c81f7",
  null
  
)

export default component.exports